module.exports = __webpack_public_path__ + "img/open-market-header-desktop.c37759a3.webp";